import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {GetShipmentsOptions, ShipmentsService} from '../services/shipments.service';
import {NgForm} from '@angular/forms';
import {catchError, combineLatest, concatMap, defer, forkJoin, from, of, Subscription, toArray} from 'rxjs';
import {Shipment} from '../services/shipment';
import {ShipmentProductLine} from '../services/shipment-product-line';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService, RecursiveHelper, User, UsersService} from '@hassel-it/angular-common';
import {ActivatedRoute, Router} from '@angular/router';
import {map, mergeMap} from 'rxjs/operators';
import {forEach} from 'lodash';
import {ShipmentEvent} from '../services/shipment-event';
import * as moment from 'moment';
import {Dayjs} from 'dayjs';
import {Package} from '../services/package';
import {ShipmentPackagesService} from '../services/shipment-packages.service';
import {BranchesService} from '../services/branches.service';
import {ShipmentEditModalComponent} from "../shipment-edit-modal/shipment-edit-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Product} from "@hassel-it/shop-services"
import {ShipmentService} from "../services/shipment-service";
import {PermissionsService} from "../permissions.service";
import {MetaFilterPipeAlt} from "../pipes/filter-pipe";


@Component({
    selector: 'app-shipments-control',
    templateUrl: './shipments-control.component.html',
    styleUrls: ['./shipments-control.component.scss'],
    providers: [ShipmentPackagesService, BranchesService]
})
export class ShipmentsControlComponent implements OnInit, AfterViewInit {

    debugMode = false;
    showDebug: any = false;
    isShipmondo = true;

    addAdditionalShipment = false;

    @ViewChild('yourInput', {static: false}) yourInput: ElementRef;
    @ViewChild('form') ngForm: NgForm;
    search: GetShipmentsOptions = {
        hideDropshipmentProductLines: false,
        showProductImages: true,
        sort: 'Shipments.created',
        direction: 'ASC'
    };

    public confirmationOptions: {
        type: 'dg' |'island'| 'dg_island'|'paint' | null,
        warning: string,
        blocking: boolean,
        must_confirm: boolean,
        has_confirmed: boolean }[] = [];

    activeShipment: Shipment = null;
    additionalShipments: Shipment[] = [];

    alertType = 'warning';
    alert: string;
    loading: boolean;
    protected shipmentComplete: boolean;
    public mode: 'bft' | null = null;
    public banner: string = null;
    public now: Dayjs;

    public lastEditedProductLine: ShipmentProductLine = null;
    public productLineQueue: ShipmentProductLine[] = [];
    public packagesQueue: Package[] = [];

    protected kolliData: { sumVolume: number, sumWeight: number,
        sumWeightOverrideActive:boolean,
        sumWeightOverride: { 0: number, 1: number, 2: number } };

    private validControlCodes = [
        '2199900000000', // IDA Afslut
    ]

    // "Print" barcode
    imageBase64 = 'iVBORw0KGgoAAAANSUhEUgAAAPYAAAAeAQMAAAAly3FkAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOxAAADsQBlSsOGwAAADRJREFUKJFj+Mx/+Pxhnj//bf7bfD58+Dw/v42N8Z8/hz8ftj/Mz/zZhmFUflR+VH7QygMAQJAQK2AXN7UAAAAASUVORK5CYII='

    public timer: any;
    public app_version?:string;

    public operationsLog: string[] = [];
    protected numberLables = 1;
    public branch = 'cla';
    public environment: { production: boolean; apiBase: string; assetBase: string; locale: string };
    public user: User;
    public userKey: string;
    private sending: boolean;
    hasErrors = false;
    errorMessage: string;

    hasValidationErrors = false;
    validationErrorMessage: string;
    public branches: any[] = [];
    public userBranch: string;
    protected boxenMode: boolean;
    public dbMode: boolean;
    protected stopBlur: boolean;
    protected hasNewVersion: boolean;
    protected showNumberLables: boolean;
    protected editPackage: boolean;
    protected product: Product;
    protected product_line: ShipmentProductLine;
    public placements: any[] = [];
    protected presetComments: string[] = [];
    protected rekvNrMode: boolean;

    constructor(public authService: AuthService,
                public activatedRoute: ActivatedRoute,
                public shipmentsService: ShipmentsService,
                public usersService: UsersService,
                public http: HttpClient,
                public shipmentPackagesService: ShipmentPackagesService,
                private router: Router,
                public branchesService: BranchesService,
                public ngbModal: NgbModal,
                public permissionsService: PermissionsService,
    ) {
        this.environment = environment;
    }

    ngOnInit() {

        this.loading = true;
        this.branches = this.branchesService.branchesDetails;

        this.resetConfirmation();

        combineLatest([
            this.activatedRoute.queryParams,
            this.usersService.getCurrentUser(),
            this.permissionsService.buildPermissions()
        ]).subscribe(([params, user]) => {
            this.user = user;
            this.userKey = user.username.split('@')[0];
            const branchField = user.custom_fields.find((item) => {
                return item.key === 'branch'
            });

            if (branchField && branchField.value) {
                this.branch = branchField.value;
                this.userBranch = branchField.value;
            }

            this.loading = false;

            if (params && params.dbMode) {
                this.dbMode = true;
            } else if (params && params.RekvNrMode) {
                this.rekvNrMode = true;
            }

            if (params && params.branch) {
                this.branch = params.branch;
            }

            if (params && params.scan) {
                this.search.nota_number = params.scan;
                this.processInput();
            }
        })

        this.timer = setInterval(() => {
            this.usersService.getCurrentUser(false).then((user) => {
                if (this.app_version && this.app_version !== user.app_version) {
                    this.hasNewVersion = true;
                    clearInterval(this.timer);
                } else {
                    this.app_version = user.app_version;
                }
            })
        }, 600000);
    }

    ngOnDestroy() {
        // Clean up interval when component is destroyed
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    setStopBlur($event) {
        this.stopBlur = true;
        $event.target.focus();
        // console.log($event);
    }

    setStartBlur($event) {
        this.stopBlur = false;
        this.focusInput();
    }

    onBlur($event: FocusEvent) {
        if (this.stopBlur) {
            return;
        }
        if ($event.relatedTarget) {
            const relatedTarget = $event.relatedTarget as Element | null; // Cast to Element or null
            if (relatedTarget.tagName === 'SELECT') {
                return;
            }
        }

        this.focusInput();
    }

    ngAfterViewInit() {
        this.focusInput();
    }

    private focusInput() {
        setTimeout(() => {
            this.yourInput.nativeElement.focus({preventScroll: true})
        }, 5);
    }

    pick($event, shipmentProductLine: ShipmentProductLine) {
        this.search.nota_number = '' + shipmentProductLine.product_number;
        setTimeout(() => {
            this.processInput($event);
        }, 2);

    }


    shipmentProductLines: ShipmentProductLine[] = [];
    populateShipmentProductLines(): void {
        const additionalShipmentProductLines = (this.additionalShipments ?? []).reduce(
            (lines: ShipmentProductLine[], shipment) => {
                return lines.concat(shipment.shipment_product_lines ?? []);
            },
            []
        );

        this.shipmentProductLines = [
            ...(this.activeShipment?.shipment_product_lines ?? []),
            ...additionalShipmentProductLines
        ];
    }

    getShipmentForProductLine(productLine: ShipmentProductLine): Shipment {
        if (this.activeShipment && productLine.shipment_id === this.activeShipment.id) {
            return this.activeShipment;
        }

        return this.additionalShipments.find((shipment) => {
            return shipment.id === productLine.shipment_id;
        });
    }

    processInput(qty = null) {

        this.operationsLog.unshift('Scanner: ' + this.search.nota_number);

        this.alert = null;
        this.lastEditedProductLine = null;

        // new control codes
        if (this.search.nota_number?.match(/^pick-start-/i)) {
            const id = this.search.nota_number.match(/^pick-start-(\d+)/)[1];
            this.shipmentsService.createShipmentEvent(ShipmentEvent.fromJSON({
                foreign_key: id,
                model: 'ShipmentPickingLists',
                status_text: '',
                date: moment(),
                shipment_status: 'packing_started',
            })).then((status => {
                console.log(status)
                this.alert = 'Plukliste startet';
                this.alertType = 'success';
            }));

            this.resetState();
            return;
        }

        if (this.search.nota_number?.match(/^pick-stop-/i)) {
            const id = this.search.nota_number.match(/^pick-stop-(\d+)/)[1];
            this.shipmentsService.createShipmentEvent(ShipmentEvent.fromJSON({
                foreign_key: id,
                model: 'ShipmentPickingLists',
                status_text: '',
                date: moment(),
                shipment_status: 'packing_completed',
            })).then((status => {
                console.log(status)
                this.alert = 'Plukliste stoppet';
                this.alertType = 'success';
            }));

            this.resetState();
            return;
        }



        if (this.activeShipment) {

            if (this.addAdditionalShipment) {
                this.shipmentsService.getShipments(1, this.search).then((result) => {
                    if (result.results.length > 0) {
                        const shipmentToAdd = result.results[0];
                        if (shipmentToAdd.id !== this.activeShipment?.id) {

                            this.additionalShipments.push(result.results[0]);
                            this.checkShipmentStatus();
                        } else {
                            this.alert = 'Kan ikke tilføje samme forsendelse';
                        }
                    }

                    this.resetState()
                });

                return;
            }

            // check for DB or EAN nummer
            const productLine = this.shipmentProductLines.
            filter((item) => {

                if (this.activeShipment.is_internal_shipment) {
                    return true;
                }

                const leftToPick = item.amount - item.amount_picked;
                if (item.amount_scanned < leftToPick) {
                    return true;
                }
                return false;
            }).
            find((line) => {
                if (line.product_number === parseInt(this.search.nota_number, 10)) {
                    return true;
                }

                if (line.product_number_ean) {

                    const eans = line.product_number_ean.split(',');
                    const test = this.eanMatches13(this.search.nota_number, eans);
                    if (test) {
                        return true;
                    }
                }
                return false;
            });
            if (productLine) {
                console.log('found', productLine);
                console.log('qty', qty);
                this.lastEditedProductLine = productLine;

                if (productLine.product_type === 'set') {
                    this.alert = 'KAN IKKE PLUKKE SÆT - PLUK DELE';
                } else if (productLine.status === 'pending_remote' || productLine.status === 'shipped_remote') {
                    this.alert = 'KAN IKKE PLUKKE DROPSHOPMENT';
                } else if (qty === 0) {
                    this.productLineQueue.splice(this.productLineQueue.indexOf(productLine), 1);
                } else {
                    if (this.activeShipment.supports_dg && productLine.dg_un && !productLine.dg_packaging) {
                        this.alert = 'Mangler emballage for farligt gods';
                    } else if (productLine.amount_picked > 0 && productLine.amount_picked === productLine.amount) {
                        this.alert = 'Antal er plukket færdig';
                    } else {
                        const leftToPick = productLine.amount - productLine.amount_picked;

                      if (productLine.amount_scanned < leftToPick || this.activeShipment.is_internal_shipment) {
                            if (qty) {
                                productLine.amount_scanned = qty;
                            } else {
                                productLine.amount_scanned = productLine.amount_scanned + 1;
                            }
                            this.operationsLog.unshift('Scanner: ' + productLine.product_number);

                            // check if this product line is in queue already
                            if (!this.productLineQueue.includes(productLine)) {
                                this.productLineQueue.push(productLine);
                            }
                        }
                    }
                }
                this.checkShipmentStatus();
                this.resetState();
                return;
            }

            // check for kontrol koder
            if (this.validControlCodes.indexOf(this.search.nota_number) !== -1) {

                const boxId = this.validControlCodes[this.validControlCodes.indexOf(this.search.nota_number)];
                if (boxId === '888') {
                    this.resetAll();
                } else if (boxId === '2199900000000' || boxId === '000') {

                    if (this.hasValidationErrors) {
                        this.alert = 'Kontroller input';
                        this.resetState();
                        return;
                    }

                    if (this.confirmationOptions.find((option) => option.must_confirm === false)) {
                        this.alert = 'Kan ikke behandle denne forsendelse';
                        this.resetState();
                        return;
                    }

                    // tslint:disable-next-line:max-line-length
                    const blocker = this.confirmationOptions.find((option) => option.must_confirm && !option.has_confirmed && option.blocking)
                    if (blocker) {
                        this.alert = 'Mangler confirmation: ' + blocker.warning;
                        this.resetState();
                        return;
                    }


                    if (this.isShipmondo) {
                        this.createPackage();
                    } else {
                        alert('ERROR 1002');
                    }
                }
            }

            if (this.search.nota_number.length === 6) {
                this.resetAll(false); // we are scanning a nota number, reset and search for that
            } else {
                this.checkShipmentStatus();
                this.resetState()
            }
        }

        if (!this.activeShipment) {
            // reset product search

            this.hasErrors = false;
            this.errorMessage = '';

            this.product_line = null;
            this.product = null;

            this.loading = true;
            this.search.branch = [this.branch];

            if (this.search.nota_number.length > 11 || this.dbMode) {
                this.shipmentsService.reloadHeaders();

                let params = new HttpParams();

                params = params.set('search', this.search.nota_number);
                this.shipmentsService.httpClient.get(environment.apiBase + '/api/ten-four/products/',
                    {
                        headers: this.shipmentsService.httpHeaders,
                        params: params,
                    }
                ).subscribe((result: any) => {
                    if (result.data && result.data.length > 0) {
                        this.product = Product.fromJSON(result.data[0]);
                        const childProducts = this.product.child_products;
                        this.product_line = this.convertProductToProductLines(this.product);
                        forEach(childProducts, (childProduct) => {
                            this.product_line.child_product_lines.push(this.convertProductToProductLines(childProduct));
                        })
                    } else {
                        this.hasErrors = true;
                        this.errorMessage = 'Kunne ikke finde produkt med nummer: ' + this.search.nota_number;
                    }
                    this.resetState();
                });

            } else if (this.rekvNrMode) {
                this.shipmentsService.getShipments(1, {
                    branch: this.search.branch,
                    rekv_number: this.search.nota_number}).then((result) => {
                    if (result.count >= 1) {
                        this.activeShipment = result.results[0];
                        this.checkShipmentStatus(true);
                        this.operationsLog.unshift('Loading shipment: ' + this.activeShipment.nota_number);
                        if (result.count > 1) {
                            this.alert = result.count + ' resultater, viser ældste'
                        }
                    } else {
                        this.alert = 'Ingen resultater - prøv igen'
                    }
                    this.resetState()
                })

            } else {

                this.shipmentsService.getShipments(1, this.search).then((result) => {


                    if (result.count >= 1) {
                        this.activeShipment = result.results[0];

                        this.checkShipmentStatus(true);
                        this.operationsLog.unshift('Loading shipment: ' + this.activeShipment.nota_number);
                        if (result.count > 1) {
                            this.alert = result.count + ' resultater, viser ældste'
                        }
                    } else {
                        this.alert = 'Ingen resultater - prøv igen'
                    }
                    this.resetState()
                })
            }

        }
    }

    resetState() {
        this.search.nota_number = null;
        this.addAdditionalShipment = false;
        this.loading = false;
    }

    checkShipmentStatus(initial: boolean = false) {
        if (this.activeShipment) {
        this.populateShipmentProductLines();
        this.packagesQueue = this.activeShipment.shipment_packages.filter(p => p.is_printed === false && !p.deleted);
            if (initial) {


                this.placements = this.placementsForBranch(this.activeShipment.branch);
                this.presetComments = this.presetCommentForBranch(this.activeShipment.branch);

                // advar hvis ø levering og danske fragtmænd
                if (
                    this.activeShipment.carrier_code === '10' &&
                    this.activeShipment.shipment_address.is_island &&
                    (!this.activeShipment?.droppoint_address || !this.activeShipment?.droppoint_address.droppoint_reference)
                ) {

                    this.confirmationOptions.push({
                        must_confirm: true,
                        blocking: true,
                        type: 'island',
                        warning: 'IKKE BROFAST Ø',
                        has_confirmed: false
                    });
                }

                if (this.activeShipment.supports_dg) {
                    const checkUn = this.activeShipment.checkUn();

                    if (checkUn) {
                        this.confirmationOptions.push({
                            blocking: false,
                            must_confirm: true,
                            type: 'dg',
                            warning: 'FARLIGT GODS',
                            has_confirmed: false
                        });
                    }
                }

                const hasPaint = this.shipmentProductLines.filter((line) => {
                    return line.product_text_3?.match(/TONES:/i) || line.note?.match(/TONES/i);
                }).find(Boolean);

                if (hasPaint) {
                    this.confirmationOptions.push({
                        blocking: true,
                        must_confirm: true,
                        type: 'paint',
                        warning: 'FORSENDELSE INDEHOLDER TONET MALING',
                        has_confirmed: false
                    });
                }


                // Redirect to boxen for afhenter i hoe
                this.boxenMode = false;
                if (this.activeShipment.carrier_code === '999' && this.branch === 'hoe') {
                    this.boxenMode = true;
                }
                this.activeShipmentPackagings = this.shipmentsService.shipmentPackagingsForCarrier(this.activeShipment.carrier_code);
            }

            /**
             * Get partial picks
             */


            // Determine banner - disabled for now
           // this.now = dayjs();
           // const cutoff = this.now.set('hour', 14).set('minute', 0).set('second', 0);
           // this.operationsLog.unshift('Scanner: ' + this.search.nota_number);
           // if (this.now.isAfter(cutoff)) {
           //     this.banner = 'Efter kl 14:00 -  placer pakke i alternativ box'
           // } else {
           //     this.banner = null;
           // }

            if (this.activeShipment.carrier_code === '212') {
                this.mode = 'bft';
            }

            // check for varer der skal have antal labels
            const enableMultiLabels = this.shipmentProductLines.filter((item) => {

                const validProductNumbers = [
                ]

                if (validProductNumbers.indexOf(item.product_number) !== -1) {
                    return true;
                }
                return false;
            });

            if (enableMultiLabels && enableMultiLabels.length > 0) {
                this.showNumberLables = true;
            } else {
                this.showNumberLables = false;
            }

            // check for varer der skal tvinge shipment til packaging_code // KUN DFM
            const presetPackaging = this.shipmentProductLines.map((item) => {

                if (this.activeShipment.carrier_code ==='10' &&  this.shipmentProductLines.length === 1 && this.shipmentProductLines[0].amount === 1) {
                    if (item.packaging_code) {
                        return this.shipmentsService.getIdForPackingType(this.activeShipment.carrier_code, item.packaging_code);
                    }
                }
            }).find(Boolean);

            if (presetPackaging) {
                this.presetPackaging = presetPackaging;
            } else {
                this.presetPackaging = null;
            }

            const missingLines = this.shipmentProductLines.filter((item) => {
                return item.amount_picked !== item.amount && item.status !== 'pending_remote'
            });
            if (missingLines && missingLines.length > 0) {
                this.shipmentComplete = false;
            } else {

                if (this.mode === 'bft' && this.productLineQueue.length > 0) {
                    this.operationsLog.unshift('Scan sidste kasse for at afslutte');
                } else {
                    this.shipmentComplete = true;
                }
            }
            this.calcualteQueue();

           //if (initial && this.activeShipment.status_ordering >= 30) {
           //    this.alert = 'Ordre er afsluttet - der kan ikke printes labels';
           //} else if (this.activeShipment.status_ordering >= 30) {
           //    this.alert = 'Ordre er afsluttet - Nulstiller';
           //    setTimeout(() => {
           //        this.resetAll();
           //    }, 3000);
           //

            if (this.activeShipment.status_ordering >= 30) {
                this.alert = 'Ordre er afsluttet';
            }
        }
    }

    resetConfirmation() {
        this.confirmationOptions = [];
    }

    resetAll(resetSearch: boolean = true) {
        this.overridePackaging = null;
        this.presetPackaging = null;
        this.selectedPackaging = null;
        this.alert = null;
        this.mode = null;
        this.numberLables = 1;
        this.boxenMode = false;
        this.activeShipment = null;
        this.additionalShipments = [];
        this.product_line = null;
        this.product = null;
        this.userBranch = this.branch;
        this.hasValidationErrors = false;
        // remove queryparam
        this.router.navigate([], { queryParams: { scan: null }, queryParamsHandling: 'merge' });
        this.resetConfirmation();
        this.resetQueue();
        if (resetSearch) {
            this.resetState();
        }
    }

    resetQueue() {
        this.productLineQueue = [];
        this.calcualteQueue();
    }

    calcualteQueue() {
        if (this.productLineQueue.length > 0) {
            this.kolliData = {
                sumWeightOverrideActive: false,
                sumWeightOverride: {0: 0, 1: 0, 2: 0},
                sumVolume: this.productLineQueue.reduce((accumulator, obj) => {
                    return accumulator + (obj.volume * obj.amount_scanned);
                }, 0),
                sumWeight: Math.round(this.productLineQueue.reduce((accumulator, obj) => {
                    return accumulator + (obj.weight * obj.amount_scanned);
                }, 0) * 100) / 100
            }
        } else {
            this.kolliData = {
                sumWeight: 0, sumVolume: 0,
                sumWeightOverrideActive: false,
                sumWeightOverride: {0: 0, 1: 0, 2: 0}
            };
        }

        this.handleValidation(false);
    }

    createPackage(addToQueue?:boolean): void {

        this.loading = true;
        this.hasErrors = false;
        this.errorMessage = null;

        let enableDg = false;


       if (this.confirmationOptions.find((option) => option.has_confirmed && option.type === 'dg')) {
           enableDg = true;
       }

       this.shipmentPackagesService.createPackageFromShipmentWithProducts(this.activeShipment, this.productLineQueue, this.activeShipmentPackagings, this.numberLables, this.branch, this.debugMode, this.kolliData.sumWeightOverride, enableDg, addToQueue)
               .pipe(mergeMap((value: any, index: number) => {
                    console.log('Package created:', value);
                       return of(value);
                   }),
                   catchError((err, caught) => {
                       const errors = [];
                       RecursiveHelper.recursiveFunction(err.error.errors, (path, value, key) => {
                           errors.push(value);
                       });
                       this.hasErrors = true;
                       this.errorMessage = errors.join(', ');
                       console.error('Error in addShipmentPackage or productLineQueue processing:', err);
                       this.loading = false;
                       return of([]); // Gracefully handle and return fallback, stopping further execution
                   })).subscribe((_ss) => {

               this.loading = false;
               if (_ss === true) {
                   this.resetAll();
               } else {
                   this.reloadShipment();
               }
           });
    }

    reloadShipment() {
        this.loading = true;
        this.search.branch = [this.branch];

        const options = {
            showProductImages: true,
            hideDropshipmentProductLines: false
        };

        const shipmentRequests = [
            from(this.shipmentsService.getShipment(this.activeShipment.id, options)),
            ...this.additionalShipments.map((shipment) =>
                from(this.shipmentsService.getShipment(shipment.id, options))
            )
        ];

        forkJoin(shipmentRequests).subscribe({
            next: ([activeShipment, ...additionalShipments]) => {
                this.activeShipment = activeShipment;
                this.additionalShipments = additionalShipments;
                this.resetQueue();
                this.checkShipmentStatus();
            },
            error: (error) => {
                console.error('Failed to reload shipment', error);
            },
            complete: () => {
                this.loading = false;
            }
        });
    }


    branchChanged() {
        this.focusInput();
    }

    leftPadZeros(s: string, len: number): string {
        if (s.length >= len) {
            return s;
        }
        return new Array(len - s.length + 1).join('0') + s;
    }

    normalizeEanTo13(ean: string | number): string {
        const digits = String(ean).replace(/\D+/g, '');
        return this.leftPadZeros(digits, 13);
    }

    eanMatches13(input: string | number, eans: Array<string | number>): boolean {
        const normInput = this.normalizeEanTo13(input);
        return eans.some(e => this.normalizeEanTo13(e) === normInput);
    }

    modalOpened($event: any) {
        this.stopBlur = $event;
        if ($event === false) {
            this.focusInput();
        }
    }

    createShipment() {
        this.stopBlur = true;
        const shipment = new Shipment();
        this.shipmentsService.createShipment(shipment).then((result) => {
            const modalRef = this.ngbModal.open(ShipmentEditModalComponent, {size: 'xl'});
            modalRef.componentInstance.modal = modalRef;
            modalRef.componentInstance.shipment = result
            modalRef.componentInstance.showDriver = true;
            modalRef.componentInstance.simple = true;
            modalRef.componentInstance.saved = (result) => {
                this.activeShipment = result;
                this.stopBlur = false;
            }
        });
    }


    overridePackageSettings() {
        this.stopBlur = !this.stopBlur;
        this.editPackage = !this.editPackage;
    }

    protected updateOverride($event: any, index: number) {
        this.kolliData.sumWeightOverrideActive = true;
        this.kolliData.sumWeightOverride[index] = $event;
    }


    protected convertProductToProductLines(product: Product): ShipmentProductLine {

        const prodline= ShipmentProductLine.fromJSON({
            id: null,
            product_number: parseInt(product.external_reference, 10),
            shipment_id: null,
            external_reference: null,
            number: 0,
            product_number_ean: product.getCustomFieldValue('eannr'),
            amount: 0,
            product_text_1: product.name,
            product_text_2: product.getCustomFieldValue('varetekst2'),
            product_text_3: product.getCustomFieldValue('varetekst3'),
            weight: parseFloat(product.getCustomFieldValue('vagtbrutto')),
            length: parseFloat(product.getCustomFieldValue('langde')),
            width: parseFloat(product.getCustomFieldValue('bredde')),
            height: parseFloat(product.getCustomFieldValue('hojde')),
            amount_picked: 0,
            created: undefined,
            modified: undefined,
            stock_location: product.getCustomFieldValue('stock_location'),
            note: "",
            note_modified: undefined,
            purchase_order: 0,
            shipment_status_formatted: "",
            status: "",
            stock: 0,
            stock_reserved: 0,
            stock_updated: undefined,
            unit: "",
            image_url: product.getThumbnail('product_full_size_v3'),
            child_product_lines: []
        });

        return prodline;
    }

    /// @todo this is copied between control and modal, needs to be refactored
    protected customProducts: any[] = [{name: null, weight: 0}];
    protected activeShipmentPackagings: any[];
    protected overridePackaging: any;
    protected selectedPackaging: any;
    private presetPackaging: number;

    selectPackaging(service: any) {
        this.overridePackaging = service;
        this.handleValidation();
    }


    public handleValidation(handleCustomProducts?: boolean) {


        if (!this.activeShipment) {
            return;
        }

        this.hasValidationErrors = true;

        if (handleCustomProducts) {

            let sumWeight = 0;
            let sumVolume = 0;

            if (this.customProducts) {
                for (const product of this.customProducts) {
                    sumWeight += parseFloat(product.weight) || 0;
                }
            }

            if (!sumWeight && this.activeShipment && this.shipmentProductLines.length > 0) {
                sumWeight = this.shipmentProductLines.reduce((accumulator, obj) => {
                    return accumulator + (obj.weight * obj.amount_scanned);
                }, 0);
            }

            this.kolliData.sumWeight = Math.round(sumWeight / 100) * 100;
        }

        this.activeShipmentPackagings = this.shipmentsService.shipmentPackagingsForCarrier(this.activeShipment.carrier_code);
        if (this.activeShipmentPackagings.length === 1) {
            this.selectedPackaging = this.activeShipmentPackagings[0];

        } else if (this.presetPackaging) {
            this.selectedPackaging = this.activeShipmentPackagings.find((item) => {
                return item.id === this.presetPackaging;
            });
        } else if (this.overridePackaging) {
            this.selectedPackaging = this.overridePackaging;
        } else {

            this.selectedPackaging = this.shipmentsService.getShipmentPackageFor(
                this.activeShipment.carrier_code,
                this.activeShipment.is_flex,
                this.activeShipment.is_business,
                this.activeShipment.is_droppoint,
                this.kolliData.sumWeight,
                this.activeShipment.shipment_address.country_code_receiver
            );
        }

        this.activeShipmentPackagings.forEach((item) => {
            item.selected = false
        });

        if (this.selectedPackaging) {

            // update the UI
            for (const packing of this.activeShipmentPackagings) {
                if (this.selectedPackaging && this.selectedPackaging.id === packing.id) {
                    packing.selected = true;
                    break;
                }
            }

            if (
                (this.selectedPackaging.minWeight <= this.kolliData.sumWeight &&
                    this.selectedPackaging.maxWeight >= this.kolliData.sumWeight
                )
                || (!this.selectedPackaging.minWeight && this.selectedPackaging.maxWeight >= this.kolliData.sumWeight)

            ) {

                this.validationErrorMessage = '';
                this.hasValidationErrors = false;

                this.activeShipment.shipment_services = this.activeShipment.shipment_services.filter((item) => {
                    return item.service_code !== 'packaging'
                })

                const dummyService = new ShipmentService();
                dummyService.service_code = 'packaging';
                dummyService.service_name = this.selectedPackaging.packageType;

                this.activeShipment.shipment_services.push(dummyService);


            } else {
                // tslint:disable-next-line:max-line-length
                this.validationErrorMessage = 'Udenfor vægt grænser (id: ' + this.selectedPackaging.id + ', ' + this.kolliData.sumWeight + ', ' + this.selectedPackaging.minWeight + ',  ' + this.selectedPackaging.maxWeight.maxWeight + ')';
                this.hasValidationErrors = true;
            }
        } else {
            this.validationErrorMessage = 'Ingen gyldig emballage fundet (' + this.kolliData.sumWeight + ')';
            this.hasValidationErrors = true;
        }
    }
    ////

    protected createEvent(event: string, onlyShipmentProductLines?: boolean) {
        this.loading = true;

        const shipmentProductLinesMetadata = [];

        const operations = [];
        switch (event) {
            case 'handed_out':
                operations.push(() => this.shipmentsService.createShipmentEvent(ShipmentEvent.fromJSON({
                    foreign_key: this.activeShipment.id,
                    model: 'Shipments',
                    status_text: this.eventComment,
                    date: moment(),
                    shipment_status: 'handed_out',
                })));
                break;
            case 'packing_completed':
            case 'packed_remote':
                for (const item of this.productLineQueue) {
                    const status = (item.amount_picked + item.amount_scanned === item.amount) ? event : 'packing_started';

                    shipmentProductLinesMetadata.push({shipment_product_line_id: item.id, amount_scanned: item.amount_scanned});
                    operations.push(() => this.shipmentsService.createShipmentEvent(ShipmentEvent.fromJSON({
                        meta_data: {amount_scanned: item.amount_scanned},
                        foreign_key: item.id,
                        model: 'ShipmentProductLines',
                        status_text: '',
                        date: moment(),
                        shipment_status: status,
                    })));
                }

                const metaData = this.activePlacements.reduce((acc, item) => {
                    acc[item] = 'true';
                    return acc;
                }, {});

                if (event === 'packed_remote') {
                    metaData['promote_to_deliverynote'] = 'true';
                    metaData['shipment_product_lines_metadata'] = shipmentProductLinesMetadata;
                    this.eventComment = 'Opløftet til følgeseddel\n' + this.eventComment;
                }

                if (!onlyShipmentProductLines) {

                operations.push(() => this.shipmentsService.createShipmentEvent(ShipmentEvent.fromJSON({
                    meta_data: metaData,
                    foreign_key: this.activeShipment.id,
                    model: 'Shipments',
                    status_text: (this.activePresetComments.length > 0 ? ('Henvendelse: ' + this.activePresetComments.join("\n") + "\n") : '') + this.eventComment,
                    date: moment(),
                    shipment_status: event,
                })));
                }

                break;
        }

        const operation = defer(() => {
            const lastOperation = operations[operations.length - 1];

            if (operations.length > 1) {
                return Promise.all(operations.slice(0, -1).map((runOperation) => runOperation()))
                    .then(() => lastOperation());
            }

            return lastOperation();
        });

        operation.subscribe((result) => {
            this.loading = false;
            this.activePlacements = [];
            this.eventComment = '';
            this.reloadShipment();
        })

    }

    private presetCommentForBranch(branch: string) {
        switch (branch) {
            case 'hoe':
                return [
                    'Gå til kassen',
                    'Gå til trælastekspeditionen'
                ]
            case 'cla':
                return [
                    'Gå til kassen',
                ];
            case 'var':
                return [
                    'Gå til kassen',
                    'Kør til hal 5'
                ];
            case 'vib':
                return [
                    'Henvendelse i ekspeditionen på lageret.\n' +
                    'Mandag - Fredag 6.30 - 16.15\n' +
                    'Lørdag 9.00 - 12.45'
                ];
            case 'vid':
                return [
                    'Gå til haveafdelingen',
                    'Gå til trælastkontoret'
                ];
            case 'ulf':
                return ['Gå til kassen', 'Gå til kassen på kontoret'];
            case 'rin':
                return ['Gå til kassen', 'Gå til trælastkontoret'];
            default:
                return [];
        }
    }

    private placementsForBranch(branch: string) {
        switch (branch) {
            case 'vid':
                return [
                    'Kontor',
                    'Hal B U-1',
                    'Hal C U-1',
                    'Udenfor porten',
                    'Læsseplads',
                ]
            case 'rin':
                return ['Afhentningsreol Byggecenter', 'Afhentningsfelt i BC. varemodtagelse', 'Køreporten', 'Udenfor Hal C', 'Reol Hal C'];
            case'ulf':
                return ['Lagerreol', 'Afhentningsreol']
            case 'var':
                return ['Hal 5'];
            case 'vid':
                return [
                    'Afhentningsreolen',
                    'Trælastkontor',
                    'Halvtag CU 1'
                ];
            case 'cla':
                return [
                    'Afh. Reol Hal 1',
                    'Afh. Reol Hal 6'
                ];
            case 'var':
                return [
                    'Hal 5',
                    'Håndværker butikken',
                ];
            case 'vib':
                return [
                    'BC Afh. reol',
                    'Hal 1',
                    'Hal 2',
                    'Hal 3',
                    'Hal 4',
                    'Hal 5',
                    'Hal 6',
                    'Hal 7',
                    'Hal 8',
                    'Varemodtagelse',
                    'Kontor',
                    'Lagerkontor',
                    'BC baglager',
                    'Afh. Reol Hal 6',
                    'Truck',
                    '1cll',
                    '2cll',
                    '3cll',
                ];
                break;
            case 'hoe':
                return [
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    // 'Boxen 1',
                    // 'Boxen 2',
                    // 'Boxen 3',
                    // 'Boxen 4',
                    // 'Boxen 5',
                    // 'Boxen 6',
                    // 'Boxen 7',
                    // 'Boxen 8',
                    // 'Boxen 9',
                    // 'Boxen 10',
                    // 'Boxen 11',
                    // 'Boxen 12',
                    // 'Boxen 13',
                    // 'Boxen 14',
                    // 'Boxen 15',
                    'K1',
                    'K2',
                    'K3',
                    'K4',
                    'K5',
                    'K6',
                    'K7',
                    'K8',
                    'K9',
                    'K10',
                    'K11',
                    'K12',
                    'K13',
                    'K14',
                    'K15',
                    'K16',
                    'K17',
                    'K18',
                    'K19',
                    'K20',
                    'K21',
                    'K22',
                    'K23',
                    'K24',
                    'K25',
                    'K26',
                    'K27',
                    'K28',
                    'K29',
                    'K30',
                    'K31',
                    'K32',
                    'K33',
                    'K34',
                    'K35',
                    'K36',
                    'K37',
                    'K38',
                    'K39',
                    'K40',
                    'W1',
                    'W2',
                    'W3',
                    'W4',
                    'W5',
                    'W6',
                    'W7',
                    'W8',
                    'W9',
                    'W10',
                    'W11',
                    'W12',
                    'W13',
                    'W14',
                    'W15',
                    'W16',
                    'W99'
                ]
                break;
        }
    }

    protected activePlacements = [];
    protected eventComment: string = '';

    protected togglePlacement(placement: any) {
        if (this.activePlacements.includes(placement)) {
            this.activePlacements = this.activePlacements.filter((item) => {
                return item !== placement;
            });
        } else {
            this.activePlacements.push(placement);
        }
    }

    protected beep(mode:string) {
        // @ts-ignore
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        let duration = 0.2;
        gainNode.gain.value = 0.2;
        if (mode === 'error') {
            oscillator.type = 'square';
            oscillator.frequency.value = 250;
duration = 0.6;

        } else {

            oscillator.type = 'sine';
            oscillator.frequency.value = 840;
            duration = 0.2;
        }

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.start();
        oscillator.stop(audioContext.currentTime + duration);
    }

    protected readonly ShipmentsService = ShipmentsService;


    protected activePresetComments = [];
    protected toggleComment(presetComment: string) {
        if (this.activePresetComments.includes(presetComment)) {
            this.activePresetComments = this.activePlacements.filter((item) => {
                return item !== presetComment;
            });
        } else {
            this.activePresetComments = [presetComment];
        }
    }

    protected printAllLabels() {
        const data = {'package_ids': this.packagesQueue.map((item) => item.id)};
        this.shipmentPackagesService.printAllLabels(this.activeShipment.id, data).subscribe(() => {
            console.log('Labels printed');
            this.reloadShipment();
        });
    }
}
